/**
 * MetaMask (and similar) inject `inpage.js` on every site. When the wallet cannot
 * connect, it throws; CRA's webpack overlay treats that as an app crash and
 * blocks the login form. This app does not use Web3 — ignore those errors only.
 */
function isWalletExtensionNoise(message: string, filename?: string): boolean {
    const haystack = `${message} ${filename || ''}`;
    return /metamask|failed to connect to metamask|nkbihfbeogaeaoehlefnkodbefgpgknn|chrome-extension:\/\//i.test(haystack);
}

export function ignoreBrowserExtensionRuntimeErrors(): void {
    window.addEventListener(
        'error',
        (event) => {
            if (isWalletExtensionNoise(event.message || '', event.filename)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        },
        true
    );
    window.addEventListener(
        'unhandledrejection',
        (event) => {
            const reason = event.reason as { message?: string } | string | undefined;
            const message = typeof reason === 'string' ? reason : reason?.message || '';
            if (isWalletExtensionNoise(message)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        },
        true
    );
}
